import {
  CircularProgress,
  Dialog,
  Grid,
  InputAdornment,
  Stack,
  SvgIcon,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Modal from '@mui/material/Modal';
import {
  getApiCall,
  Moxoseparationinlisting,
  postApiCall,
} from 'api/apiService';
import mailicon from 'assets/images/mailicon.png';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import {
  BUYER_SOLICITOR,
  GETBUYER_SOLICITOR_BY_ID,
  SOLICITOR_CHECK_IN,
} from 'constant/app.config';
import { datacontext } from 'modules/AppLayout/AppLayout';
import React, { useContext, useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { validateEmail } from 'utils/validation.util';
import { makeStyles } from '@mui/styles';
import Loading from 'assets/images/loading.png';
import {
  headStyle,
  labelText,
  solicitButton,
  style,
  TextFieldError,
} from './SolicitorStyle';
import { useTheme } from '@emotion/react';
import { Warning } from 'component/BuyersMarketplace/MakeOffers';
import { poppins300, poppins400 } from 'theme/common.style';

const AddUser = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 45 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5597 3.10742C10.3925 3.10742 7.04636 6.4531 7.04636 10.6207C7.04636 14.7874 10.393 18.134 14.5597 18.134C18.7273 18.134 22.073 14.7878 22.073 10.6207C22.073 6.45264 18.7277 3.10742 14.5597 3.10742ZM14.5606 5.22635C17.5582 5.22635 19.9547 7.62277 19.9547 10.6204C19.9547 13.6172 17.5577 16.0145 14.5606 16.0145C11.5643 16.0145 9.16647 13.6167 9.16647 10.6204C9.16647 7.62329 11.5638 5.22635 14.5606 5.22635ZM14.5584 20.7054C7.45193 20.7054 3.42969 22.0539 3.42969 25.8748C3.42969 29.7 7.46978 31.074 14.5584 31.074L15.4675 31.0662C22.0053 30.952 25.687 29.5584 25.687 25.9045C25.687 22.1625 21.8207 20.7663 15.0163 20.7073L14.5584 20.7054ZM14.5593 22.8243C20.4951 22.8243 23.5687 23.8696 23.5687 25.9042C23.5687 27.9263 20.5026 28.9545 14.5593 28.9545C8.6234 28.9545 5.54979 27.9092 5.54979 25.8746C5.54979 23.9063 8.45079 22.8806 14.0835 22.8266L14.5593 22.8243ZM27.7358 11.4696C28.2723 11.4696 28.7156 11.8682 28.7857 12.3854L28.7954 12.5292V14.3021H30.6244C31.2096 14.3021 31.684 14.7765 31.684 15.3617C31.684 15.8982 31.2854 16.3415 30.7682 16.4117L30.6244 16.4213H28.7954V18.1946C28.7954 18.7798 28.321 19.2542 27.7358 19.2542C27.1994 19.2542 26.756 18.8555 26.6859 18.3384L26.6762 18.1946V16.4213H24.846C24.2608 16.4213 23.7864 15.9469 23.7864 15.3617C23.7864 14.8253 24.1851 14.382 24.7023 14.3118L24.846 14.3021H26.6762V12.5292C26.6762 11.944 27.1506 11.4696 27.7358 11.4696Z"
        fill="#112347"
      />
    </svg>
  );
};

export const BasicModal = ({
  open,
  setOpen,
  dashboard,
  propertyId,
  updatefunc,
  opensolicitor,
  setOpensolicitor,
  atInitial,
  handleCloseparent,
}) => {
  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const buyerID = userDetail?.userId;
  const { solicitorupdate, setSolicitorupdate } = useContext(datacontext);

  // Refs for autofix
  const nameInputRef = useRef(null);
  const lastNameInputRef = useRef(null);
  const emailInputRef = useRef(null);

  // Fix autofill on mount and when dialog opens
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (nameInputRef.current) {
          nameInputRef.current.setAttribute('readonly', true);
          nameInputRef.current.removeAttribute('readonly');
        }
        if (lastNameInputRef.current) {
          lastNameInputRef.current.setAttribute('readonly', true);
          lastNameInputRef.current.removeAttribute('readonly');
        }
        if (emailInputRef.current) {
          emailInputRef.current.setAttribute('readonly', true);
          emailInputRef.current.removeAttribute('readonly');
        }
      }, 100);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    if (opensolicitor) {
      setOpensolicitor(false);
    }
    setFormValues(initialState);
    if (atInitial == true && handleCloseparent) {
      handleCloseparent();
    }
  };

  //update form state
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   const updatedValue = name == 'userEmail' ? value.toLowerCase() : value;
  //   setFormValues({
  //     ...formValues,
  //     [name]: {
  //       ...formValues[name],
  //       value: updatedValue,
  //       error: false,
  //     },
  //   });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'name') {
      let filtered = value.replace(/[^A-Za-z\s]/g, '');
      let formatted = filtered.replace(/\b\w/g, (char) => char.toUpperCase());

      setFormValues({
        ...formValues,
        name: {
          ...formValues.name,
          value: formatted,
          error: false,
        },
      });

      if (formatted.trim().length > 0) {
        solicitorCheckin(formatted.trim());
        setAnchorEl('name');
      } else {
        setAnchorEl('');
      }

      return;
    }

    if (name === 'userType') {
      let filtered = value.replace(/[^A-Za-z\s]/g, '');
      let formatted = filtered.replace(/\b\w/g, (char) => char.toUpperCase());

      setFormValues({
        ...formValues,
        userType: {
          ...formValues.userType,
          value: formatted,
          error: false,
        },
      });

      if (formatted.trim().length > 0) {
        solicitorCheckin(formatted.trim());
        setAnchorEl('userType');
      } else {
        setAnchorEl('');
      }

      return;
    }

    if (name === 'userEmail') {
      let emailValue = value.toLowerCase();

      setFormValues({
        ...formValues,
        userEmail: {
          ...formValues.userEmail,
          value: emailValue,
          error: false,
        },
      });

      if (emailValue.trim().length > 0) {
        solicitorCheckin(emailValue.trim());
        setAnchorEl('userEmail');
      } else {
        setAnchorEl('');
      }

      return;
    }

    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
        error: false,
      },
    });
  };

  const initialState = {
    name: {
      value: '',
      error: false,
      errorMessage: 'Please enter the name',
    },
    userType: {
      value: '',
      error: false,
      errorMessage: 'Please enter surname',
    },
    userEmail: {
      value: '',
      error: false,
      errorMessage: 'E​nter a valid email address',
    },
  };
  //form values state
  const [formValues, setFormValues] = React.useState(initialState);
  const [loading, setLoading] = React.useState(false);

  const [name, setName] = React.useState('');

  const { setLoaderConfig } = React.useContext(LoaderContext);
  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const signUpHandler = (formData) => {
    setLoading(true);
    const inputData = {
      solicitorName:
        formData.name.value.charAt(0).toUpperCase() +
        formData.name.value.slice(1)?.trim(),
      solicitorSurName:
        formData.userType.value.charAt(0).toUpperCase() +
        formData.userType.value.slice(1)?.trim(),
      solicitorEmail: formData.userEmail.value,
      propertyId: propertyId != 'dashboard' ? Number(propertyId) : 0,
      solicitorMobile: null,
      solicitorAddress: null,
      buyerId: buyerID,
      isBuyerSolicitor: 1,
    };
    postApiCall(BUYER_SOLICITOR, inputData)
      .then(async (res) => {
        // localStorage.setItem('localSolicitorID' , res?.data?.solicitorId )
        setLoaderConfig({ isVisible: false });
        if (res?.data?.status == '1') {
          if (isNotEmptyArray(res?.data?.bsbPropertyBinder))
            await Moxoseparationinlisting(
              'dataForSolBinder',
              res?.data?.bsbPropertyBinder
            ); //1
          if (isNotEmptyArray(res?.data?.vsvPropertyBinder))
            await Moxoseparationinlisting(
              'dataForSolBinder',
              res?.data?.vsvPropertyBinder
            ); //2
          if (updatefunc) {
            updatefunc();
          }
          setLoading(false);
          //buyer solicitor getapi
          if (primaryUserTypeValue == 'Buyer') {
            getApiCall(GETBUYER_SOLICITOR_BY_ID).then((res) => {
              if (res?.data?.status == 1) {
                localStorage.setItem('buyerSolicitor', 'Yes');
                localStorage.setItem(
                  'buyerSolicitorDetails',
                  JSON.stringify(res?.data?.data)
                );
              } else {
                setLoading(false);
                localStorage.setItem('buyerSolicitor', 'No');
              }
            });
          }
          //change form values state
          setFormValues(initialState);
          setOpen(false);
          if (opensolicitor) {
            setOpensolicitor(false);
          }
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Success',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              if (propertyId != 'dashboard') {
                setSolicitorupdate(!solicitorupdate);
              }
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
          setLoading(false);
        }
      })
      .catch(() => setLoading(false));
  };
  //checking form validation
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(formValues.userEmail.value)) {
      let triggerSubmit = true;
      const formFields = Object.keys(formValues);
      let newFormValues = { ...formValues };
      for (let index = 0; index < formFields.length; index++) {
        const currentField = formFields[index];
        const currentValue = formValues[currentField].value;
        if (currentValue === '') {
          triggerSubmit = false;
          newFormValues = {
            ...newFormValues,
            [currentField]: {
              ...newFormValues[currentField],
              error: true,
            },
          };
        }
      }
      setFormValues(newFormValues);
      //form validation is true then post api function trigger
      if (triggerSubmit) {
        signUpHandler(newFormValues);
      }
    } else {
      setFormValues((prevState) => ({
        ...prevState,
        userEmail: {
          value: formValues.userEmail.value,
          error: true,
          errorMessage: 'E​nter a valid email address',
        },
      }));
    }
  };
  const theme = useTheme();
  const matches850 = useMediaQuery(theme.breakpoints.down(850));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matches370 = useMediaQuery(theme.breakpoints.down(370));
  const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiInputBase-input': {
        height: '10px',
        backgroundColor: 'rgba(255, 255, 255, 1)',
        border: '2px solid grey',
        padding: 'none',
      },
    },
  }));
  const classes = useStyles();
  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  const [anchorEl, setAnchorEl] = useState('');
  const [checkInIndex, setCheckInIndex] = useState('');
  const [checkInData, setCheckInData] = useState([]);
  const [foundData, setFoundData] = useState(false);

  const solicitorCheckin = (data) => {
    if (!data || data.length === 0) return;

    const inputData = {
      contactValue: data,
    };

    setFoundData(true);

    postApiCall(SOLICITOR_CHECK_IN, inputData).then(async (res) => {
      if (res?.data?.status == 1) {
        setCheckInData(res?.data);
      } else {
        setCheckInData([]);
      }
      setFoundData(false);
    });
  };

  const handleFocus = (field) => {
    setAnchorEl(field);
    const currentValue = formValues?.[field]?.value?.trim();
    if (currentValue) {
      solicitorCheckin(currentValue);
    } else {
      setCheckInData([]);
    }
  };
  return (
    <Dialog
      PaperProps={{
        className: classes.DialogBox,
        style: {
          width: '100%',
          position: 'fixed',
        },
      }}
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <form onSubmit={handleSubmit} noValidate autoComplete="off">
        {/* Chrome autofill blocker - hidden fake fields */}
        <div style={{ display: 'none' }}>
          <input type="text" name="fakeusername" autoComplete="username" />
          <input
            type="password"
            name="fakepassword"
            autoComplete="current-password"
          />
          <input type="email" name="fakeemail" autoComplete="email" />
          <input type="text" name="fakename" autoComplete="name" />
        </div>

        <Grid sx={{ padding: matches400 ? '10px' : '30px' }}>
          <Typography
            sx={[
              headStyle(matches850, matches400),
              { display: 'flex', alignItems: 'center' },
            ]}
          >
            <Warning /> &nbsp; Onboarding Legal Representative
          </Typography>
          <Grid
            container
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <Grid item xs={12}>
              <Typography sx={labelText(matches850, matches400)} variant="h6">
                First Name
              </Typography>
              <Box sx={{ position: 'relative' }}>
                <TextField
                  inputRef={nameInputRef}
                  sx={[
                    TextFieldError,
                    {
                      '& .MuiInputBase-input::placeholder': {
                        textTransform: 'none',
                        fontFamily: 'Poppins',
                      },
                    },
                  ]}
                  id="outlined-basic"
                  placeholder="Legal rep's First name"
                  variant="outlined"
                  InputLabelProps={{ shrink: false, fontSize: '40px' }}
                  type="text"
                  name="name"
                  fullWidth
                  autoComplete="new-password"
                  // required
                  onChange={handleChange}
                  onFocus={() => handleFocus('name')}
                  value={formValues.name.value}
                  error={formValues.name.error}
                  helperText={
                    formValues.name.error && formValues.name.errorMessage
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SvgIcon
                          fontSize="large"
                          style={{
                            paddingRight: '8px',
                            // marginRight:"10px",
                            borderRight: '1px solid',
                            color: '#000000',
                          }}
                        >
                          <AddUser />
                        </SvgIcon>
                      </InputAdornment>
                    ),
                    onKeyPress: (event) => {
                      const charCode = event.which
                        ? event.which
                        : event.keyCode;
                      if (charCode >= 48 && charCode <= 57) {
                        event.preventDefault();
                      }
                    },
                  }}
                  inputProps={{
                    maxLength: 25,
                    style: {
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    },
                  }}
                />
                {anchorEl === 'name' &&
                  (formValues.name.value.trim() ||
                    checkInData?.userData?.length > 0) && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        minWidth: '320px',
                        maxHeight: '270px',
                        overflow: 'hidden',
                        backgroundColor: '#fff',
                        boxShadow: 3,
                        zIndex: 10000,
                        borderRadius: '4px',
                      }}
                    >
                      <Box
                        sx={{
                          maxHeight: '150px',
                          overflowY: 'scroll',
                          paddingLeft: 2,
                          paddingTop: 1,
                        }}
                      >
                        {checkInData?.userData?.length > 0
                          ? checkInData.userData.map((item, i) => (
                              <Box
                                key={i}
                                sx={{
                                  padding: 1,
                                  cursor: 'pointer',
                                  '&:hover': { backgroundColor: '#f5f5f5' },
                                }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,
                                    name: {
                                      value: item.userName,
                                      error: false,
                                    },
                                    userType: {
                                      value: item.userSurName,
                                      error: false,
                                    },
                                    userEmail: {
                                      value: item.userEmail,
                                      error: false,
                                    },
                                  });
                                  setAnchorEl('');
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontWeight: 300,
                                    fontSize: '14px',
                                  }}
                                >
                                  {item.userName} {item.userSurName}
                                </Typography>{' '}
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontWeight: 300,
                                    fontSize: '12px',
                                    color: '#666',
                                  }}
                                >
                                  {item.userEmail}
                                </Typography>
                              </Box>
                            ))
                          : formValues.name.value.trim() && (
                              <Typography
                                sx={{
                                  padding: 2,
                                  ...poppins400,

                                  fontSize: '14px',
                                }}
                              >
                                No existing contact available
                              </Typography>
                            )}
                      </Box>

                      {formValues.name.value.trim() && (
                        <>
                          <Divider />

                          <Box sx={{ textAlign: 'center', padding: 1 }}>
                            <Typography
                              onClick={() => setAnchorEl('')}
                              sx={{
                                cursor: 'pointer',
                                color: '#007BFF',
                                ...poppins400,
                                fontSize: '14px',
                              }}
                            >
                              + Add "{formValues.name.value}" as new contact
                            </Typography>
                          </Box>
                        </>
                      )}
                    </Box>
                  )}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={labelText(matches850, matches400)} variant="h6">
                Last Name
              </Typography>
              <Box sx={{ position: 'relative' }}>
                <TextField
                  inputRef={lastNameInputRef}
                  sx={[
                    TextFieldError,
                    {
                      '& .MuiInputBase-input::placeholder': {
                        textTransform: 'none',
                        fontFamily: 'Poppins',
                      },
                      '& .MuiInputBase-input': {
                        fontSize: matches370 && '14px',
                      },
                    },
                  ]}
                  // required
                  id="outlined-basic"
                  placeholder="Legal rep's last name"
                  variant="outlined"
                  InputLabelProps={{ shrink: false, fontSize: '40px' }}
                  type="text"
                  name="userType"
                  fullWidth
                  autoComplete="new-password"
                  onChange={handleChange}
                  onFocus={() => handleFocus('userType')}
                  value={formValues.userType.value}
                  error={formValues.userType.error}
                  helperText={
                    formValues.userType.error &&
                    formValues.userType.errorMessage
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SvgIcon
                          fontSize="large"
                          style={{
                            paddingRight: '8px',
                            // marginRight:"10px",
                            borderRight: '1px solid',
                            color: '#000000',
                          }}
                        >
                          <AddUser />
                        </SvgIcon>
                      </InputAdornment>
                    ),
                    onKeyPress: (event) => {
                      const charCode = event.which
                        ? event.which
                        : event.keyCode;
                      if (charCode >= 48 && charCode <= 57) {
                        event.preventDefault();
                      }
                    },
                  }}
                  inputProps={{
                    maxLength: 25,
                    style: {
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    },
                  }}
                />
                {anchorEl === 'userType' &&
                  (formValues.userType.value.trim() ||
                    checkInData?.userData?.length > 0) && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        width: '100%',
                        minWidth: '320px',
                        backgroundColor: '#fff',
                        boxShadow: 3,
                        zIndex: 10000,
                        borderRadius: '4px',
                        maxHeight: '270px',
                        overflow: 'hidden',
                      }}
                    >
                      <Box
                        sx={{
                          overflowY: 'scroll',
                          maxHeight: '150px',
                          paddingLeft: 2,
                          paddingTop: 1,
                          scrollbarWidth: 'thin',
                          '&::-webkit-scrollbar': { width: '6px' },
                          '&::-webkit-scrollbar-thumb': { background: '#888' },
                        }}
                      >
                        {checkInData?.userData?.length > 0
                          ? checkInData.userData.map((item, i) => (
                              <Box
                                key={i}
                                sx={{
                                  padding: 1,
                                  cursor: 'pointer',
                                  '&:hover': { backgroundColor: '#f2f2f2' },
                                }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,
                                    name: {
                                      value: item.userName,
                                      error: false,
                                    },
                                    userType: {
                                      value: item.userSurName,
                                      error: false,
                                    },
                                    userEmail: {
                                      value: item.userEmail,
                                      error: false,
                                    },
                                  });
                                  setAnchorEl('');
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontWeight: 300,
                                    fontSize: '14px',
                                    color: '#333',
                                  }}
                                >
                                  {item.userName} {item.userSurName}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontWeight: 300,
                                    fontSize: '12px',
                                    color: '#777',
                                  }}
                                >
                                  {item.userEmail}
                                </Typography>
                              </Box>
                            ))
                          : formValues.userType.value.trim() && (
                              <Typography
                                sx={{
                                  padding: 2,
                                  ...poppins400,
                                  fontSize: '14px',
                                }}
                              >
                                No existing contact available
                              </Typography>
                            )}
                      </Box>

                      {formValues.userType.value.trim() && (
                        <>
                          <Divider />

                          <Box
                            sx={{
                              textAlign: 'center',
                              padding: 1,
                              cursor: 'pointer',
                            }}
                            onClick={() => setAnchorEl('')}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'Poppins',
                                fontWeight: 400,
                                fontSize: '14px',
                                color: '#007BFF',
                              }}
                            >
                              + Add "{formValues.userType.value}" as new contact
                            </Typography>
                          </Box>
                        </>
                      )}
                    </Box>
                  )}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={labelText(matches850, matches400)} variant="h6">
                Email Address
              </Typography>
              <Box sx={{ position: 'relative' }}>
                <TextField
                  inputRef={emailInputRef}
                  sx={TextFieldError}
                  // required
                  id="userEmail"
                  placeholder="name@Example:.com.au"
                  variant="outlined"
                  name="userEmail"
                  autoComplete="new-password"
                  inputProps={{ style: { fontFamily: 'poppins' } }}
                  onKeyDown={(e) => {
                    if (e.key === ' ') {
                      e.preventDefault();
                    }
                  }}
                  onFocus={() => handleFocus('userEmail')}
                  onChange={handleChange}
                  value={formValues.userEmail.value}
                  error={formValues.userEmail.error}
                  helperText={
                    formValues.userEmail.error &&
                    formValues.userEmail.errorMessage
                  }
                  InputLabelProps={{ shrink: false }}
                  type="email"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          alt="img"
                          src={mailicon}
                          style={{
                            background: 'transparent',
                            paddingRight: '10px',
                            borderRight: '1px solid black',
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                {anchorEl === 'userEmail' &&
                  (formValues.userEmail.value.trim() ||
                    checkInData?.userData?.length > 0) && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        width: '100%',
                        minWidth: '320px',
                        backgroundColor: '#fff',
                        boxShadow: 3,
                        zIndex: 10000,
                        borderRadius: '4px',
                        maxHeight: '270px',
                        overflow: 'hidden',
                      }}
                    >
                      <Box
                        sx={{
                          overflowY: 'scroll',
                          maxHeight: '150px',
                          paddingLeft: 2,
                          paddingTop: 1,
                          scrollbarWidth: 'thin',
                          '&::-webkit-scrollbar': { width: '6px' },
                          '&::-webkit-scrollbar-thumb': { background: '#888' },
                        }}
                      >
                        {checkInData?.userData?.length > 0
                          ? checkInData.userData.map((item, i) => (
                              <Box
                                key={i}
                                sx={{
                                  padding: 1,
                                  cursor: 'pointer',
                                  '&:hover': { backgroundColor: '#f2f2f2' },
                                }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,
                                    name: {
                                      value: item.userName,
                                      error: false,
                                    },
                                    userType: {
                                      value: item.userSurName,
                                      error: false,
                                    },
                                    userEmail: {
                                      value: item.userEmail,
                                      error: false,
                                    },
                                  });
                                  setAnchorEl('');
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontWeight: 300,
                                    fontSize: '14px',
                                    color: '#333',
                                  }}
                                >
                                  {item.userName} {item.userSurName}
                                </Typography>

                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontWeight: 300,
                                    fontSize: '12px',
                                    color: '#777',
                                  }}
                                >
                                  {item.userEmail}
                                </Typography>
                              </Box>
                            ))
                          : formValues.userEmail.value.trim() && (
                              <Typography
                                sx={{
                                  padding: 2,
                                  ...poppins400,
                                  fontSize: '14px',
                                }}
                              >
                                No existing contact available
                              </Typography>
                            )}
                      </Box>

                      {formValues.userEmail.value.trim() && (
                        <>
                          <Divider />

                          <Box
                            sx={{
                              textAlign: 'center',
                              padding: 1,
                              cursor: 'pointer',
                            }}
                            onClick={() => setAnchorEl('')}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'Poppins',
                                fontWeight: 400,
                                fontSize: '14px',
                                color: '#007BFF',
                              }}
                            >
                              + Add "{formValues.userEmail.value}" as new
                              contact
                            </Typography>
                          </Box>
                        </>
                      )}
                    </Box>
                  )}
              </Box>
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '50px',
            }}
          >
            <Button
              sx={solicitButton}
              style={{
                color: 'rgb(102, 102, 102)',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                textTransform: 'none',
              }}
              disabled={loading}
              variant="outlined"
              // color="error"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Stack
              direction={'row '}
              width={'45%'}
              alignItems={'center'}
              justifyContent={'end'}
            >
              <Button
                style={{
                  background: 'rgb(76, 164, 214)',
                  color: '#ffff',
                  textTransform: 'none',
                  width: '100%',
                }}
                sx={solicitButton}
                variant="contained"
                disabled={loading}
                // color="success"
                type="submit"
              >
                Invite
              </Button>
              {loading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Stack>
          </Grid>
        </Grid>
      </form>
    </Dialog>
  );
};
